import React from 'react'
import { motion } from 'framer-motion';

// Note: this no longer owns the outer grid wrapper - the parent (Dashboard.jsx)
// owns one shared grid so a 5th, non-generic card (SmsUsageCard) can sit in
// the same row as these. containerVariants/initial/animate now live on that
// shared wrapper instead.
const StatsGrid = ({statsData, cardVariants}) => {
  return (
    <>
      {statsData.map((stat, index) => (
        <motion.div
          key={index}
          variants={cardVariants}
          whileHover={{
            scale: 1.02,
            y: -5,
            transition: { duration: 0.2 },
          }}
          className="p-6 bg-white rounded-xl border border-gray-200 shadow-sm transition-shadow duration-200 hover:shadow-md"
        >
          <div className="flex items-center">
            <motion.div
              className={`p-2 ${stat.bgColor} rounded-lg`}
              whileHover={{ rotate: 360 }}
              transition={{ duration: 0.6, ease: "easeInOut" }}
            >
              <stat.icon className={`w-6 h-6 ${stat.textColor}`} />
            </motion.div>
            <div className="ml-4">
              <p className="text-sm font-medium text-gray-600">
                {stat.title}
              </p>
              <p className="text-2xl font-bold text-gray-900">
                {stat.value}
              </p>
            </div>
          </div>
        </motion.div>
      ))}
    </>
  );
};

export default StatsGrid;